<template>
  <v-container class="px-5 bg-background">
    <v-card-title class="text-pwt_black pt-5 d-flex flex-column flex-md-row justify-space-between px-0">
      <span> Favourite locations </span>
      <!-- add new location button -->
      <ElevatedBlockBtn v-if="mobile" @click="addLocationPreCheck">Add a location</ElevatedBlockBtn>
      <ElevatedBtn v-else @click="addLocationPreCheck">Add a location</ElevatedBtn>
    </v-card-title>
    <!-- not authed warning -->
    <v-card-text v-if="!isAuthorised" class="pl-0">
      To view or create favourite locations please <LoginLink />.
    </v-card-text>
    <!-- fav location list -->
    <template v-else-if="favLocations.length">    
      <FavLocationCard
        v-for="favLocation in favLocations"
        :key="favLocation.localId"
        :favLocation="favLocation"
        @remove="deleteFavLocation"
        @edit="editFavLocation"
      />
    </template>
    <!-- no fav locations empty state filler -->
    <v-card-text v-else class="pl-0">
      You have no favourite locations.
    </v-card-text>
    <!-- dialog windows -->
    <FavLocationAddDialog :activator="showAddDialog" @close="showAddDialog = false" />
    <FavLocationEditDialog
      v-if="editingFavLocation"
      :activator="showEditDialog"
      :favLocation="typedEditingFavLocation"
      @close="showEditDialog = false"
    />
  </v-container>
</template>
<script lang="ts" setup>
import { deleteFavouriteLocation } from '@/api/calls/directus-calls/favourite-locations-calls'
import FavouriteLocation from '@/classes/favouriteLocation'
import { MutationTypes, type PreAuthAction, type State } from '@/store/store_types'
import { computed, ref } from 'vue'
import { useDisplay } from 'vuetify'
import { useStore } from 'vuex'
import LoginLink from '../auth/LoginLink.vue'
import ElevatedBlockBtn from '../ui-elements/buttons/ElevatedBlockBtn.vue'
import ElevatedBtn from '../ui-elements/buttons/ElevatedBtn.vue'
import FavLocationAddDialog from './FavLocationAddDialog.vue'
import FavLocationCard from './FavLocationCard.vue'
import FavLocationEditDialog from './FavLocationEditDialog.vue'

const store = useStore<State>()
const { mobile } = useDisplay()

const favLocations = computed(() => store.state.favLocations)

const showAddDialog = ref(false)
const showEditDialog = ref(false)
const editingFavLocation = ref<FavouriteLocation | undefined>(undefined)
const typedEditingFavLocation = computed(() => editingFavLocation.value as FavouriteLocation) // Warning: only use if showingTrip is defined. Workaround foe TS cant match class private properties see https://github.com/microsoft/TypeScript/issues/42683 for unhelpful but working as intended behaviour

/**
 * Edits a favourite location by opening the edit dialog and setting the
 * editingFavLocation data property to the provided favourite location.
 *
 * @param {FavouriteLocation} favLocation - The favourite location to edit.
 * @return {void} This function does not return anything.
 */
function editFavLocation(favLocation: FavouriteLocation): void {
  editingFavLocation.value = favLocation
  showEditDialog.value = true
}

/**
 * Deletes a favourite location from the store.
 *
 * @param {FavouriteLocation} favLocation - The favourite location to delete.
 * @return {void} This function does not return anything.
 */
function deleteFavLocation(favLocation: FavouriteLocation): void {
  store.commit(MutationTypes.deleteFavLocation, favLocation.localId)
  if (favLocation.directusId) {
    deleteFavouriteLocation(favLocation.directusId)
  }
}

const isAuthorised = computed(() => store.state.authorizedFlag)

function addLocationPreCheck() {
  if (isAuthorised.value) {
    showAddDialog.value = true
  } else {
    store.commit(MutationTypes.setRetuning_auth_action, 'add_location' as PreAuthAction)
    store.commit(MutationTypes.setShow_account_needed, true) // show account needed alert
  }
}

</script>
